// extracted by mini-css-extract-plugin
export default {"container":"blog_container__UxTqS","heading":"blog_heading__GgPxy"};